<template>
    <div class="wang-editor-control">
        <!-- Read-only mode: render HTML directly -->
        <div v-if="readonly" class="wang-editor-readonly" v-html="currentValue"></div>
        <!-- Editable mode: wangEditor instance -->
        <div v-else :id="editorId" class="wang-editor-instance"></div>
    </div>
</template>

<script>
import Editor from 'wangeditor';

let uidCounter = 0;

export default {
    name: 'WangEditorControl',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: '请输入内容'
        },
        height: {
            type: [Number, String],
            default: 300
        },
        uploadImgShowBase64: {
            type: Boolean,
            default: true
        },
        showLinkImg: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            editorId: 'wang-editor-' + (++uidCounter),
            editor: null,
            currentValue: this.value || ''
        };
    },
    watch: {
        value(val) {
            const v = val || '';
            // Compare against the editor's last known content instead of using a
            // boolean flag: echoes of our own onchange emit are naturally equal and
            // skipped, while a genuine external update is never swallowed. (The old
            // isInternalChange flag could get stuck when a debounced onchange emitted
            // a value identical to the parent's, silently dropping the next update.)
            if (v === this.currentValue) {
                return;
            }
            this.currentValue = v;
            if (this.editor && !this.readonly) {
                this.editor.txt.html(v);
            }
        },
        readonly(val) {
            if (val) {
                // Switching to read-only: destroy editor, currentValue is already synced
                this.destroyEditor();
            } else {
                // Switching to editable: create editor
                this.$nextTick(() => {
                    this.createEditor();
                });
            }
        }
    },
    mounted() {
        if (!this.readonly) {
            this.$nextTick(() => {
                this.createEditor();
            });
        }
    },
    beforeDestroy() {
        this.destroyEditor();
    },
    methods: {
        createEditor() {
            if (this.editor) {
                this.destroyEditor();
            }
            const dom = document.getElementById(this.editorId);
            if (!dom) return;

            this.editor = new Editor('#' + this.editorId);
            this.editor.config.height = this.height;
            this.editor.config.uploadImgShowBase64 = this.uploadImgShowBase64;
            this.editor.config.showLinkImg = this.showLinkImg;
            this.editor.config.placeholder = this.placeholder;
            this.editor.config.zIndex = 100;

            this.editor.config.onchange = (html) => {
                // Track the editor's content so the value watcher can recognize
                // the echo of this emit by equality and skip it
                this.currentValue = html;
                this.$emit('change', html);
            };

            this.editor.create();

            // Set initial content after editor is fully initialized
            if (this.currentValue) {
                this.editor.txt.html(this.currentValue);
            }
        },
        destroyEditor() {
            if (this.editor) {
                try {
                    this.editor.destroy();
                } catch (e) {
                    // Editor may already be destroyed
                }
                this.editor = null;
            }
        }
    }
};
</script>

<style scoped>
.wang-editor-control {
    width: 100%;
}

.wang-editor-readonly {
    min-height: 120px;
    max-height: 400px;
    overflow-y: auto;
    padding: 10px 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #f5f7fa;
    color: #606266;
    line-height: 1.8;
    word-wrap: break-word;
    word-break: break-all;
}

.wang-editor-readonly >>> img {
    max-width: 100%;
}

.wang-editor-readonly >>> ul,
.wang-editor-readonly >>> ol {
    padding-left: 20px;
}

.wang-editor-readonly >>> li {
    list-style-type: disc;
}

.wang-editor-readonly >>> ol li {
    list-style-type: decimal;
}

.wang-editor-instance {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
}
</style>
